import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgGridNotifyService {
  private readonly reloadSubject: Subject<void> = new Subject();
  private readonly refreshDataSubject: Subject<void> = new Subject();
  private readonly updateFiltersSubject: Subject<any> = new Subject();
  private readonly tabChangedSubject: Subject<any> = new Subject();

  get onReload() {
    return this.reloadSubject.asObservable();
  }

  get onRefreshData() {
    return this.refreshDataSubject.asObservable();
  }

  get onUpdateFilters(): Observable<any> {
    return this.updateFiltersSubject.asObservable();
  }

  get onSelectedTabChanged(): Observable<any> {
    return this.tabChangedSubject.asObservable();
  }

  constructor() {}

  public reload() {
    this.reloadSubject.next();
  }

  public refreshData() {
    this.refreshDataSubject.next();
  }

  public updateFilters(filterModel: any) {
    this.updateFiltersSubject.next(filterModel);
  }

  public selectedTabChanged(activeTab: any) {
    this.tabChangedSubject.next(activeTab);
  }
}
